/**
 * A count as the UI prints it: thousands grouped, `1542` → `1,542`
 * (flowstack#1978).
 *
 * The locale is pinned to `en-US` rather than left to the browser. The UI's
 * copy is English throughout, and an unpinned `toLocaleString()` prints
 * `1.542` under a German locale — which reads as one and a half beside
 * English labels.
 */
export function formatCount(value: number): string {
  return value.toLocaleString("en-US");
}
